<template>
  <div class="tel">
    <div class="wrap">
      <h5>校园服务电话</h5>
      <div class="content">
        <div class="content_top">
          <section class="left">
            <p>学校信访办：67843328</p>
            <p>校园110：67843110</p>
            <p>学生管理科：67842955</p>
            <p>心理咨询预约：67842501</p>
            <p>学生宿管中心：67842796</p>
            <p>学生资助中心：67842722</p>
          </section>
          <section class="rigth">
            <p>研究生院：67842498</p>
            <p>团委（社团活动）：67841396</p>
            <p>教务处：67843341</p>
            <p>食堂服务：15927076739</p>
            <p>校园网服务：67843672</p>
            <p>教室网络设备服务：67843900</p>
          </section>
        </div>

        <div class="content_bottom">
          <section class="left">
            <p>水电中心电话：67842055</p>
            <p>校园卡服务：67842559、67841627、87058095（北区）</p>
            <p>校医院急诊：15802793857</p>
            <p>毕业生就业：67842082</p>
            <p>毕业生档案：67841629</p>
            <p>毕业生党组织关系咨询：67844311</p>
            <p>学校法律援助中心：67843217</p>
            <p>物业服务：87383036（东区）、87572081（西区及当代）</p>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {

    }
  }
}
</script>
<style scoped>
.wrap {
  width: calc(100% - 2.5rem);
  /* height: 33.75rem; */
  height: 31.06rem;
  margin-top: 1rem;
  background: url(../../static/assets/tel_bg1.png) no-repeat;
  background-size: 100% 100%;
  /* color: #fff; */
  padding: 1.25rem;
}

.wrap h5 {
  font-size: 1.5rem;
  margin-bottom: 1.25rem;
}

.wrap p {
  font-size: 1rem;
  margin-bottom: 0.625rem;
}

.content_top {
  display: flex;
  align-items: center;
  margin-bottom: 1.25rem;
}

.content_top section {
  width: 50%;
}
</style>


// WEBPACK FOOTER //
// tel.vue?68ae7127